import { useState, useCallback } from 'react';
import { isValid } from 'date-fns';
import { DatePicker } from '@/components/ui/datepicker';

export interface ResponseDateFieldProps {
  value?: number | Date;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  label?: string;
  error?: boolean;
  allowPastDates?: boolean;
}

export const ResponseDateField = ({
  onChange,
  disabled,
  value,
  allowPastDates = true,
}: ResponseDateFieldProps) => {
  const [, setError] = useState(false);
  const [date, setDate] = useState<Date | null>(value ? new Date(value) : null);

  const handleChange = useCallback(
    (date: Date) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(date);
      selectedDate.setHours(0, 0, 0, 0);

      const isValidDate = isValid(date);
      const isPastDate = !allowPastDates && selectedDate < today;

      if (isValidDate && !isPastDate) {
        onChange(date.getTime());
        setDate(date);
        setError(false);
      } else {
        onChange(null);
        setError(true);
      }
    },
    [onChange, allowPastDates],
  );

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <div className="w-full">
      <DatePicker
        value={date}
        onChange={(selected) => {
          if (selected) handleChange(selected);
        }}
        disabled={disabled}
        placeholder="__/__/____"
        minDate={allowPastDates ? undefined : today}
      />
    </div>
  );
};
